export default {"src":"/_next/static/media/ml-logo-dark.c36685f7.svg","height":40,"width":175,"blurWidth":0,"blurHeight":0};